{
  "CRMConfiguration_Table_Headers_Description": "Description",
  "CRMConfiguration_Table_Headers_Type": "Type",
  "CRMConfiguration_Table_Headers_TelSys": "Telephony Server",
  "CRMConfiguration_Table_Headers_Partition": "Partition",
  "CRMConfiguration_Table_Headers_Device": "Device",
  "NAME": "CRMConfigurationLanguage"
}